import * as yup from 'yup'

const requiredMsg = 'Esse campo é obrigatório!'

export const forgotSchema = yup
  .object({
    email: yup.string().required(requiredMsg), // Email or username
  })
  .required()
